<!--
 * @Description:
 * @Author: Ingyi
 * @Date: 2021-09-02 16:34:07
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-03 15:34:03
-->
<template>
  <div class="register-page">
    <div class="register-content">
      <div style="width: 800px; margin: 20px auto">
        <a-tabs type="card" @change="callback">
          <a-tab-pane key="1" tab="个人用户注册">
            <a-form-model ref="ruleForm" :model="form" v-bind="layout">
              <a-form-model-item label="联系电话">
                <a-input v-model="form.userPhone" :maxLength="11" @change="handleTel()" style="width: 466px" />
              </a-form-model-item>
              <a-form-model-item label="密码">
                <a-input type="password" v-model="form.password" :maxLength="50" />
              </a-form-model-item>
              <a-form-model-item label="确认密码">
                <a-input type="password" v-model="form.commitPassoword" />
              </a-form-model-item>
              <a-form-model-item label="身份证号">
                <a-input v-model="form.idCardNo" :maxLength="18" />
              </a-form-model-item>
              <a-form-model-item label="姓名">
                <a-input v-model="form.adminName" :maxLength="50" />
              </a-form-model-item>
              <a-form-model-item label="身份证正面">
                <a-upload list-type="picture" :default-file-list="fileList" :locale="locale" method="post" name="file"
                  action="/newapp/api/common/attachment/" @change="(item) => handleChangegeidzheng(item)">
                  <a-button> <a-icon type="upload" /> 上传 </a-button>
                </a-upload>
              </a-form-model-item>
              <a-form-model-item label="身份证反面">
                <a-upload list-type="picture" :default-file-list="fileList" :locale="locale" method="post" name="file"
                  action="/newapp/api/common/attachment/" @change="(item) => handleChangegeidfan(item)">
                  <a-button> <a-icon type="upload" /> 上传 </a-button>
                </a-upload>
              </a-form-model-item>
            </a-form-model>
            <div class="submit-btn">
              <a-button type="primary" @click="handleSubmit">提交</a-button>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="企业用户注册" :forceRender="true">
            <a-form-model ref="ruleForm2" :model="form2" v-bind="layout">
              <a-form-model-item label="企业名称">
                <a-input v-model="form2.name" />
              </a-form-model-item>
              <!-- <a-form-model-item label="类型">
                <a-select v-model="form2.type">
                  <a-select-option v-for="item in orgs" :key="item.key">{{
                    item.value
                  }}</a-select-option>
                </a-select>
              </a-form-model-item> -->
              <a-form-model-item label="联系人">
                <a-input v-model="form2.concat" :maxLength="50" />
              </a-form-model-item>
              <a-form-model-item label="联系人电话">
                <a-input v-model="form2.concatPhone" :maxLength="11" @change="handleTel1()" style="width: 466px" />
              </a-form-model-item>
              <a-form-model-item label="法人姓名">
                <a-input v-model="form2.legalPerson" :maxLength="50" />
              </a-form-model-item>
              <a-form-model-item label="法人联系电话">
                <a-input v-model="form2.legalPersonPhone" :maxLength="11" @change="handleTel2()" style="width: 466px" />
              </a-form-model-item>
              <a-form-model-item label="法人身份证号">
                <a-input v-model="form2.idCardNo" :maxLength="18" />
              </a-form-model-item>
              <a-form-model-item label="营业执照号码">
                <a-input v-model="form2.businessLicense" :maxLength="25" />
              </a-form-model-item>
              <a-form-model-item label="企业注册地址">
                <a-input v-model="form2.address" :maxLength="200" />
              </a-form-model-item>
              <a-form-model-item label="企业电话">
                <a-input v-model="form2.enterprisePhone" :maxLength="12" style="width: 466px" />
              </a-form-model-item>
              <a-form-model-item label="企业邮箱">
                <a-input v-model="form2.enterpriseEmail" :maxLength="50" />
              </a-form-model-item>
              <a-form-model-item label="企业介绍">
                <a-textarea v-model="form2.enterpriseDesc" style="height: 250px" :maxLength="500" />
              </a-form-model-item>
              <a-form-model-item label="营业执照">
                <a-upload list-type="picture" :default-file-list="fileList" :locale="locale" method="post" name="file"
                  action="/newapp/api/common/attachment/" @change="(item) => handleChangeqiyezhizhao(item)">
                  <a-button> <a-icon type="upload" /> 上传 </a-button>
                </a-upload>
              </a-form-model-item>
              <a-form-model-item label="身份证正面">
                <a-upload list-type="picture" :default-file-list="fileList" :locale="locale" method="post" name="file"
                  action="/newapp/api/common/attachment/" @change="(item) => handleChangeqigezheng(item)">
                  <a-button> <a-icon type="upload" /> 上传 </a-button>
                </a-upload>
              </a-form-model-item>
              <a-form-model-item label="身份证反面">
                <a-upload list-type="picture" :default-file-list="fileList" :locale="locale" method="post" name="file"
                  action="/newapp/api/common/attachment/" @change="(item) => handleChangeqigefan(item)">
                  <a-button> <a-icon type="upload" /> 上传 </a-button>
                </a-upload>
              </a-form-model-item>
              <a-form-model-item label="公司宣传图">
                <a-upload list-type="picture" :default-file-list="fileList" :locale="locale" method="post" name="file"
                  action="/newapp/api/common/attachment/" @change="(item) => handleChange(item, 2)">
                  <a-button> <a-icon type="upload" /> 上传 </a-button>
                </a-upload>
              </a-form-model-item>

              <a-form-model-item label="密码">
                <a-input type="password" v-model="form2.password" :maxLength="50" />
              </a-form-model-item>
              <a-form-model-item label="确认密码">
                <a-input type="password" v-model="form2.commitPassoword" :maxLength="50" />
              </a-form-model-item>
            </a-form-model>
            <div class="submit-btn">
              <a-button type="primary" @click="handleSubmit2">提交</a-button>
            </div>
          </a-tab-pane>
          <a-tab-pane key="3" tab="代理机构注册" :forceRender="true">
            <a-form-model ref="ruleForm3" :model="form3" v-bind="layout">
              <a-form-model-item label="企业名称">
                <a-input v-model="form3.name" />
              </a-form-model-item>

              <!-- <a-form-model-item label="类型">
                <a-select v-model="form2.type">
                  <a-select-option v-for="item in orgs" :key="item.key">{{
                    item.value
                  }}</a-select-option>
                </a-select>
              </a-form-model-item> -->
              <a-form-model-item label="联系人">
                <a-input v-model="form3.concat" :maxLength="50" />
              </a-form-model-item>
              <a-form-model-item label="联系人电话">
                <a-input v-model="form3.concatPhone" :maxLength="11" @change="handleTel4()" style="width: 466px" />
              </a-form-model-item>
              <a-form-model-item label="法人姓名">
                <a-input v-model="form3.legalPerson" :maxLength="50" />
              </a-form-model-item>
              <a-form-model-item label="法人联系电话">
                <a-input v-model="form3.legalPersonPhone" :maxLength="11" @change="handleTel4()" style="width: 466px" />
              </a-form-model-item>
              <a-form-model-item label="法人身份证号">
                <a-input v-model="form3.idCardNo" :maxLength="18" />
              </a-form-model-item>
              <a-form-model-item label="营业执照号码">
                <a-input v-model="form3.businessLicense" :maxLength="25" />
              </a-form-model-item>
              <a-form-model-item label="企业注册地址">
                <a-input v-model="form3.address" :maxLength="200" />
              </a-form-model-item>
              <a-form-model-item label="企业联系电话">
                <a-input v-model="form3.enterprisePhone" :maxLength="11" @change="handleTel6()" style="width: 466px" />
              </a-form-model-item>
              <a-form-model-item label="身份证正面">
                <a-upload list-type="picture" :default-file-list="fileList" :locale="locale" method="post" name="file"
                  action="/newapp/api/common/attachment/" @change="(item) => handleChangedaigezheng(item)">
                  <a-button> <a-icon type="upload" /> 上传 </a-button>
                </a-upload>
              </a-form-model-item>
              <a-form-model-item label="身份证反面">
                <a-upload list-type="picture" :default-file-list="fileList" :locale="locale" method="post" name="file"
                  action="/newapp/api/common/attachment/" @change="(item) => handleChangedaigefan(item)">
                  <a-button> <a-icon type="upload" /> 上传 </a-button>
                </a-upload>
              </a-form-model-item>
              <a-form-model-item label="营业执照">
                <a-upload list-type="picture" :default-file-list="fileList" :locale="locale" method="post" name="file"
                  action="/newapp/api/common/attachment/" @change="(item) => handleChangedaizhizhao(item)">
                  <a-button> <a-icon type="upload" /> 上传 </a-button>
                </a-upload>
              </a-form-model-item>
              <a-form-model-item label="代理机构资质">
                <!-- handleAgenChange -->
                <a-upload list-type="picture" :default-file-list="fileList" :locale="locale" method="post" name="file"
                  action="/newapp/api/common/attachment/" @change="handleAgenChange">
                  <a-button> <a-icon type="upload" /> 上传 </a-button>
                </a-upload>
              </a-form-model-item>
              <a-form-model-item label="企业邮箱">
                <a-input v-model="form3.enterpriseEmail" :maxLength="50" />
              </a-form-model-item>
              <a-form-model-item label="企业介绍">
                <!-- <div id="editor2"></div> -->
                <a-textarea v-model="form3.enterpriseDesc" style="height: 250px" :maxLength="500" />
              </a-form-model-item>
              <a-form-model-item label="代理机构宣传图">
                <a-upload list-type="picture" :default-file-list="fileList" :locale="locale" method="post" name="file"
                  action="/newapp/api/common/attachment/" @change="(item) => handleChange(item, 3)">
                  <a-button> <a-icon type="upload" /> 上传 </a-button>
                </a-upload>
              </a-form-model-item>

              <a-form-model-item label="密码">
                <a-input type="password" v-model="form3.password" :maxLength="50" />
              </a-form-model-item>
              <a-form-model-item label="确认密码">
                <a-input type="password" v-model="form3.commitPassoword" :maxLength="50" />
              </a-form-model-item>
            </a-form-model>
            <div class="submit-btn">
              <a-button type="primary" @click="handleSubmit3">提交</a-button>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import request from "../util/request";
// import Quill from "quill";
// import "quill/dist/quill.snow.css";
import { encrypt } from "@/util/jsencrypt";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
export default {
  name: "register",
  data() {
    return {
      locale,
      mode: 1,
      orgs: [],
      form: {},
      form2: {},
      form3: {},
      datainfo: {},
      fileList: [],
      paramValue: {},
      paramValue2: {},
      paramValue3: {},
      quill: null,
      quill2: null,
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 14 },
      },
    };
  },
  mounted() {
    this.queryDict();
    // this.quill = new Quill("#editor", {
    //   theme: "snow",
    // });

    // this.quill2 = new Quill("#editor2", {
    //   theme: "snow",
    // });
  },
  methods: {
    callback() { },
    queryDict() {
      request({
        url: "/api/client/common/select/dict/list",
        params: { key: "ORG_TYPE" },
      }).then((res) => {
        this.orgs = res.data;
      });
    },
    handleChange(info, key) {
      if (info.file.status === "done") {
        console.log(info);
        this["form" + key].agencyzLogo = info.file.response.data.url;
        this.$message.success(`${info.file.name} 文件上传成功`);
      }
    },
    handleAgenChange(info) {
      if (info.file.status === "done") {
        console.log(info);
        this.form3.qualification = info.file.response.data.url;
        this.$message.success(`${info.file.name} 文件上传成功`);
      }
    },
    handleChangeqiyezhizhao(info) {
      if (info.file.status === "done") {
        console.log(info);
        this.form2.businessLicenseImg = info.file.response.data.url;
        this.$message.success(`${info.file.name} 文件上传成功`);
      }
    },
    handleChangedaizhizhao(info) {
      if (info.file.status === "done") {
        console.log(info);
        this.form3.businessLicenseImg = info.file.response.data.url;
        this.$message.success(`${info.file.name} 文件上传成功`);
      }
    },
    handleChangedaigezheng(info) {
      if (info.file.status === "done") {
        console.log(info);
        this.form3.idCardFont = info.file.response.data.url;
        this.$message.success(`${info.file.name} 文件上传成功`);
      }
    },
    handleChangedaigefan(info) {
      if (info.file.status === "done") {
        console.log(info);
        this.form3.idCardBack = info.file.response.data.url;
        this.$message.success(`${info.file.name} 文件上传成功`);
      }
    },
    handleTel() {
      if (isNaN(this.form.userPhone)) {
        this.form.userPhone = "";
      }
    },
    handleTel1() {
      if (isNaN(this.form2.concatPhone)) {
        this.form2.concatPhone = "";
      }
    },
    handleTel2() {
      if (isNaN(this.form2.legalPersonPhone)) {
        this.form2.legalPersonPhone = "";
      }
    },
    handleTel3() {
      if (isNaN(this.form2.enterprisePhone)) {
        this.form2.enterprisePhone = "";
      }
    },
    handleTel4() {
      if (isNaN(this.form3.concatPhone)) {
        this.form3.concatPhone = "";
      }
    },
    handleTel5() {
      if (isNaN(this.form3.legalPersonPhone)) {
        this.form3.legalPersonPhone = "";
      }
    },
    handleTel6() {
      if (isNaN(this.form3.enterprisePhone)) {
        this.form3.enterprisePhone = "";
      }
    },

    isRealNum(val) {
      // isNaN()函数 把空串 空格 以及NUll 按照0来处理 所以先去除，
      if (val === "" || val == null) {
        return false;
      }
      if (!isNaN(val)) {
        return true;
      } else {
        return false;
      }
    },
    handleChangeqigezheng(info) {
      if (info.file.status === "done") {
        console.log(info);
        this.form2.idCardFont = info.file.response.data.url;
        this.$message.success(`${info.file.name} 文件上传成功`);
      }
    },
    handleChangeqigefan(info) {
      if (info.file.status === "done") {
        console.log(info);
        this.form2.idCardBack = info.file.response.data.url;
        this.$message.success(`${info.file.name} 文件上传成功`);
      }
    },
    handleChangegeidzheng(info) {
      if (info.file.status === "done") {
        console.log(info);
        this.form.idCardFont = info.file.response.data.url;
        this.$message.success(`${info.file.name} 文件上传成功`);
      }
    },
    handleChangegeidfan(info) {
      if (info.file.status === "done") {
        console.log(info);
        this.form.idCardBack = info.file.response.data.url;
        this.$message.success(`${info.file.name} 文件上传成功`);
      }
    },

    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (
            typeof this.form.userPhone == "undefined" ||
            this.form.userPhone == null ||
            this.form.userPhone == ""
          ) {
            this.$message.error("联系电话不能为空");
            return false;
          }
          if (
            this.form.userPhone &&
            !/^1[1356789]\d{9}$/.test(this.form.userPhone)
          ) {
            this.$message.warning("联系电话不符合规范");
            return false;
          }
          this.paramValue = JSON.parse(JSON.stringify(this.form));
          console.log("数据加密之前")
          console.log(this.form)
          this.paramValue.password = encrypt(this.paramValue.password);
          this.paramValue.commitPassoword = encrypt(this.paramValue.commitPassoword);
          this.paramValue.idCardNo = encrypt(this.paramValue.idCardNo);
          this.paramValue.adminName = encrypt(this.paramValue.adminName);
          this.paramValue.userPhone = encrypt(this.paramValue.userPhone);
          console.log("数据加密之后")
          console.log(this.paramValue)
          request({
            url: "/api/client/common/register/user",
            method: "post",
            params: this.paramValue,
          }).then((res) => {
            if (res.code == "200") {
              this.$message.success("注册成功");
              this.$router.push("/login");
            } else {
              this.$message.warning(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    handleSubmit2() {
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          this.form2.type = this.orgs[0].key;
          if (
            typeof this.form2.concatPhone == "undefined" ||
            this.form2.concatPhone == null ||
            this.form2.concatPhone == ""
          ) {
            this.$message.error("联系电话不能为空");
            return false;
          }
          if (
            this.form2.concatPhone &&
            !/^1[1356789]\d{9}$/.test(this.form2.concatPhone)
          ) {
            this.$message.warning("联系电话不符合规范");
            return false;
          }
          if (
            typeof this.form2.legalPersonPhone == "undefined" ||
            this.form2.legalPersonPhone == null ||
            this.form2.legalPersonPhone == ""
          ) {
            this.$message.error("法人联系电话不能为空");
            return false;
          }
          if (
            this.form2.legalPersonPhone &&
            !/^1[1356789]\d{9}$/.test(this.form2.legalPersonPhone)
          ) {
            this.$message.warning("法人联系电话不符合规范");
            return false;
          }
          let isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
          let isMobes = /^1[1356789]\d{9}$/;
          if (
            typeof this.form2.enterprisePhone == "undefined" ||
            this.form2.enterprisePhone == null ||
            this.form2.enterprisePhone == ""
          ) {
            this.$message.error("企业电话不能为空");
            return false;
          }
          if (
            !isPhone.test(this.form2.enterprisePhone) &&
            !isMobes.test(this.form2.enterprisePhone)
          ) {
            this.$message.warning("企业电话不符合规范");
            return false;
          }
          this.paramValue2 = JSON.parse(JSON.stringify(this.form2));
          this.paramValue2.concat = encrypt(this.paramValue2.concat);
          this.paramValue2.concatPhone = encrypt(this.paramValue2.concatPhone);
          this.paramValue2.legalPerson = encrypt(this.paramValue2.legalPerson);
          this.paramValue2.legalPersonPhone = encrypt(this.paramValue2.legalPersonPhone);
          this.paramValue2.enterpriseEmail = encrypt(this.paramValue2.enterpriseEmail);
          this.paramValue2.idCardNo = encrypt(this.paramValue2.idCardNo);
          this.paramValue2.businessLicense = encrypt(this.paramValue2.businessLicense);
          this.paramValue2.enterprisePhone = encrypt(this.paramValue2.enterprisePhone);
          this.paramValue2.password = encrypt(this.paramValue2.password);
          this.paramValue2.commitPassoword = encrypt(this.paramValue2.commitPassoword);
          request({
            url: "/api/client/common/register/enterprise",
            method: "post",
            params: this.paramValue2,
          }).then((res) => {
            if (res.code == "200") {
              this.$message.success("注册成功");
              this.$router.push("/login");
            } else {
              this.$message.warning(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleSubmit3() {
      this.$refs.ruleForm3.validate((valid) => {
        if (valid) {
          this.form3.type = this.orgs[1].key;
          if (
            typeof this.form3.concatPhone == "undefined" ||
            this.form3.concatPhone == null ||
            this.form3.concatPhone == ""
          ) {
            this.$message.error("联系电话不能为空");
            return false;
          }
          if (
            this.form3.concatPhone &&
            !/^1[1356789]\d{9}$/.test(this.form3.concatPhone)
          ) {
            this.$message.warning("联系电话不符合规范");
            return false;
          }
          if (
            typeof this.form3.legalPersonPhone == "undefined" ||
            this.form3.legalPersonPhone == null ||
            this.form3.legalPersonPhone == ""
          ) {
            this.$message.error("法人联系电话不能为空");
            return false;
          }
          if (
            this.form3.legalPersonPhone &&
            !/^1[1356789]\d{9}$/.test(this.form3.legalPersonPhone)
          ) {
            this.$message.warning("法人联系电话不符合规范");
            return false;
          }
          let isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
          let isMobes = /^1[1356789]\d{9}$/;
          if (
            typeof this.form3.enterprisePhone == "undefined" ||
            this.form3.enterprisePhone == null ||
            this.form3.enterprisePhone == ""
          ) {
            this.$message.error("企业电话不能为空");
            return false;
          }
          if (
            !isPhone.test(this.form3.enterprisePhone) &&
            !isMobes.test(this.form3.enterprisePhone)
          ) {
            this.$message.warning("企业电话不符合规范");
            return false;
          }
          this.paramValue3 = JSON.parse(JSON.stringify(this.form3));
          this.paramValue3.concat = encrypt(this.paramValue3.concat);
          this.paramValue3.legalPerson = encrypt(this.paramValue3.legalPerson);
          this.paramValue3.legalPersonPhone = encrypt(this.paramValue3.legalPersonPhone);
          this.paramValue3.idCardNo = encrypt(this.paramValue3.idCardNo);
          this.paramValue3.businessLicense = encrypt(this.paramValue3.businessLicense);
          this.paramValue3.enterprisePhone = encrypt(this.paramValue3.enterprisePhone);
          this.paramValue3.enterpriseEmail = encrypt(this.paramValue3.enterpriseEmail);
          this.paramValue3.password = encrypt(this.paramValue3.password);
          this.paramValue3.commitPassoword = encrypt(this.paramValue3.commitPassoword);
          this.paramValue3.concatPhone = encrypt(this.paramValue3.concatPhone);
          request({
            url: "/api/client/common/register/enterprise",
            method: "post",
            params: this.paramValue3,
          }).then((res) => {
            if (res.code == "200") {
              this.$message.success("注册成功");
              this.$router.push("/login");
            } else {
              this.$message.warning(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleFormLayoutChange(params) {
      console.log("handleFormLayoutChange", params);
    },
  },
};
</script>
<style lang="less">
.register-page {
  .banner {
    width: 100%;
    height: 140px;
    background: #ddd;

    .logo-box {
      width: 310px;
      height: 140px;
      background: #fff;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  .register-content {
    width: 1280px;
    margin: 0 auto;
    background: #fff;

    h2 {
      text-align: center;
      line-height: 80px;
    }
  }

  .submit-btn {
    display: flex;
    height: 80px;
    justify-content: center;
    align-items: center;
  }
}
</style>
